import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ReplyIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11" fill="currentColor" />
  </svg>
);

ReplyIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ReplyIcon);
